export const getInsuranceCompanies = (state) => state.insuranceCompany.entries;
